import { DateTime } from 'luxon';
import { combineActions, handleActions } from 'redux-actions';

import { EPOCH_ISO } from '../../utils/date';
import { resourceUndoUpserters, resourceUpserters } from '../core';

import * as actions from './goalsActions';
import { mkGoalsStore, mkUpdateGoal } from './goalsTypes';

const goalsReducer = handleActions(
  {
    [actions.createGoal]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.createGoalSuccess]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.deleteGoal),

    [actions.updateGoal]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateGoal),
    [actions.updateGoalSuccess]: (state, { payload: goal }) => resourceUpserters.upsertResource(state, goal),

    [actions.deleteGoal]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.createGoal),
    [actions.deleteGoalSuccess]: (state, { payload: goal }) => resourceUpserters.upsertResource(state, goal),

    [actions.getGoals]: (state) => state.set('isLoading', true),
    [actions.getGoalsSuccess]: (state, { payload: data, asyncDispatch }) => {
      // we need to check if the most recent calculations completed or uncompleted a goal
      const { resources: goalsList } = data;
      goalsList.forEach((goal) => {
        if (goal.isDeleted) return;
        if (goal.savedSoFar >= goal.targetAmount && (!goal.completedOn || goal.completedOn === EPOCH_ISO)) {
          // first if the goal has saved >= the target and isn't complete we complete it
          asyncDispatch(
            actions.updateGoal(
              mkUpdateGoal(goal.type, {
                id: goal.id,
                completedOn: DateTime.local().toISO(),
              }),
            ),
          );
        } else if (goal.savedSoFar < goal.targetAmount && goal.completedOn && goal.completedOn !== EPOCH_ISO) {
          // else if the goal has saved < than the target and the goal is currently marked as completed
          asyncDispatch(
            actions.updateGoal(
              mkUpdateGoal(goal.type, {
                id: goal.id,
                completedOn: EPOCH_ISO,
              }),
            ),
          );
        }
      });
      // finally return the upserted resource
      return resourceUpserters.upsertResources(state, data);
    },
    [actions.getGoalsFailure]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),

    [combineActions(actions.createGoalFailure, actions.updateGoalFailure, actions.deleteGoalFailure)]: (
      state,
      { payload: error, asyncDispatch },
    ) => {
      asyncDispatch(actions.getGoals());
      return resourceUpserters.resetResources(state, error);
    },

    [actions.updateChangedGoals]: (state, { payload: goals }) =>
      resourceUpserters.upsertResources(state, { resources: goals }),
  },
  mkGoalsStore(),
);

export const REDUCER_KEY = 'goalStore';
export default goalsReducer;
